import { render } from "./topbar-course.vue?vue&type=template&id=9cd86f00&ts=true"
import script from "./topbar-course.vue?vue&type=script&lang=ts"
export * from "./topbar-course.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__